import "./MonitoreoCatalogo.css";
import { BasePageComponent } from "../../../shared/components/pages/BasePageComponent";
import { MonitoreoEstadoFenologicoResponse } from "../../../shared/response/comun/MonitoreoEstadoFenologicoResponse";
import { MonitoreoEstadoFenologicoService } from "../../../shared/services/comun/MonitoreoEstadoFenologicoService";
import { errorMessageComponent } from "../../../shared/components/error/ErrorMessageComponent";

export class EstadosFenologicosPage extends BasePageComponent {
  private _all:      MonitoreoEstadoFenologicoResponse[] = [];
  private _filtered: MonitoreoEstadoFenologicoResponse[] = [];

  private _tbody!:  HTMLTableSectionElement;
  private _totEl!:  HTMLSpanElement;
  private _search!: HTMLInputElement;

  public getAppRoute(): string { return "/monitoreo/estados-fenologicos"; }
  public getPageTitle(): string | null { return "Estados fenológicos"; }

  protected override renderPageContent(pageContent: HTMLDivElement): void {
    pageContent.className = "sx-page mon-page";
    pageContent.innerHTML = `
      <div class="mon-content">
        <div class="mon-pg-hd">
          <div>
            <div class="mon-pg-ey">Monitoreo · Catálogo</div>
            <div class="mon-pg-ti">Estados fenológicos</div>
            <div class="mon-pg-su">Etapas del ciclo del cultivo</div>
          </div>
        </div>

        <div class="mon-frow">
          <div class="mon-sw">
            <i class="ph ph-magnifying-glass" aria-hidden="true"></i>
            <input class="mon-si" id="mon-search" placeholder="Buscar código o descripción…">
          </div>
          <span class="mon-ftot" id="mon-tot"></span>
        </div>

        <div class="mon-tbl-wrap">
          <table class="mon-tbl">
            <thead>
              <tr>
                <th style="width:80px">Orden</th>
                <th style="width:140px">Código</th>
                <th>Descripción</th>
              </tr>
            </thead>
            <tbody id="mon-tbody">
              <tr><td colspan="3" class="mon-empty">Cargando…</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    `;

    this._tbody  = document.getElementById("mon-tbody")! as HTMLTableSectionElement;
    this._totEl  = document.getElementById("mon-tot")!;
    this._search = document.getElementById("mon-search")! as HTMLInputElement;
    this._search.oninput = () => this._filterAndRender();

    void this._loadData();
  }

  protected override beforeDispose(): void {}

  private async _loadData(): Promise<void> {
    try {
      const items = await MonitoreoEstadoFenologicoService.instance.get();
      this._all = items
        .filter((e) => !e.isEliminado)
        .sort((a, b) => Number(a.orden) - Number(b.orden));
      this._filterAndRender();
    } catch (error) {
      errorMessageComponent.addError("Error al cargar estados fenológicos", (error as Error).message);
      this._tbody.innerHTML = `<tr><td colspan="3" class="mon-empty">Error al cargar</td></tr>`;
    }
  }

  private _filterAndRender(): void {
    const q = this._search.value.toLowerCase().trim();
    this._filtered = this._all.filter((e) =>
      !q || e.codigo.toLowerCase().includes(q) || e.descripcion.toLowerCase().includes(q),
    );
    this._renderTable();
  }

  private _renderTable(): void {
    const list = this._filtered;
    this._totEl.textContent = `${list.length} estado${list.length === 1 ? "" : "s"}`;

    if (list.length === 0) {
      this._tbody.innerHTML = `<tr><td colspan="3" class="mon-empty">Sin resultados</td></tr>`;
      return;
    }

    this._tbody.innerHTML = list.map((e) => `
      <tr>
        <td class="mon-orden">${e.orden}</td>
        <td class="mon-codigo">${this._esc(e.codigo)}</td>
        <td>${this._esc(e.descripcion)}</td>
      </tr>`).join("");
  }

  private _esc(s: string): string {
    return (s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
}
